import { defineComponent as _defineComponent } from 'vue'
import SFButton from '@/components/ui/button/Button.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import { inject, ref } from 'vue'
import { FireRiskDashboardViewModel } from '../viewmodels/FireRiskDashboard.viewmodel'
import DataPicker from '@/components/ui/dataPicker/DataPicker.vue'
import { FireRiskEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireRisk.enum'
import { FireOutbreakOccurrenceEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakOccurence.enum'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireAlertsFilterDto } from '../dtos/FireAlertsFilter.dto'
import { onClickOutside } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireAlertsFilter',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {



const filter = ref()

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const fireAlertsFilter = ref<FireAlertsFilterDto>({ ...vm.initFireAlertsFilter })

const isFileringOpen = ref(false)

const riskTypes = [
	{ label: 'Nulo', value: FireRiskEnum.NONE },
	{ label: 'Pequeno', value: FireRiskEnum.SMALL },
	{ label: 'Médio', value: FireRiskEnum.MEDIUM },
	{ label: 'Alto', value: FireRiskEnum.HIGH },
	{ label: 'Muito Alto', value: FireRiskEnum.HIGHEST },
]

const occurrence = [
	{ label: 'Fazenda', value: FireOutbreakOccurrenceEnum.FARM },
	{ label: 'Buffer', value: FireOutbreakOccurrenceEnum.BUFFER },
]

const reactions = [
	{ label: 'Positivo', value: FireOutbreakReactionEnum.POSITIVE },
	{ label: 'Negativo', value: FireOutbreakReactionEnum.NEGATIVE },
	{ label: 'Indeterminado', value: FireOutbreakReactionEnum.IMPOSSIBLE },
	{ label: 'Sem avaliação', value: undefined },
]

function setFilter() {
	vm.fireAlertsFilter.value = { ...fireAlertsFilter.value }
	closeFilter()
}

function clearFilter() {
	fireAlertsFilter.value = { ...vm.initFireAlertsFilter }
	vm.clearFilter()
	closeFilter()
}

function openFilter() {
	isFileringOpen.value = true
}

function closeFilter() {
	isFileringOpen.value = false
}

onClickOutside(filter, closeFilter)

return { __sfc: true,filter, vm, fireAlertsFilter, isFileringOpen, riskTypes, occurrence, reactions, setFilter, clearFilter, openFilter, closeFilter, SFButton, Dropdown, DataPicker }
}

})